<template lang="html">
    <div class="section-schedule" id="schedule">
        <h2>Schedule</h2>
        <section class="cd-container"  id="cd-timeline">
            <!-- waypoint handler functions -->
            <v-waypoint
            @waypoint-in="$store.dispatch('updateSticky')"
            @waypoint-out="$store.dispatch('updateSticky')"
            ></v-waypoint>

            <timelineblock v-for="(timelineblock, index) in timelineblocks" :day="index + 1" :cd_cls="timelineblock.cd_cls" :schedules="timelineblock.schedule" :key="index"></timelineblock>

            <!-- waypoint handler functions -->
            <v-waypoint
            @waypoint-in="$store.dispatch('updateSticky')"
            @waypoint-out="$store.dispatch('updateSticky')"
            ></v-waypoint>
        </section>
    </div>
</template>

<script>
import TimelineBlock from './TimelineBlock.vue';
import schedule_data from '../../data/schedule';

export default {
    data() {
        return {
            timelineblocks: schedule_data
        }
    },
    components: {
        'timelineblock': TimelineBlock
    }
}
</script>

<style lang="scss">
.section-schedule {
    background-color: #f4f4f4;
    padding-top: 3rem;
}
</style>



// WEBPACK FOOTER //
// Schedules.vue?0d2b1e55